var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.LiveInfos = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  var LiveInfos = function LiveInfos(_ref) {
    var className = _ref.className,
        isLive = _ref.isLive,
        labels = _ref.labels,
        liveDate = _ref.liveDate,
        liveDuration = _ref.liveDuration,
        liveTime = _ref.liveTime;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('live-infos', className)
    }, isLive && /*#__PURE__*/_react.default.createElement("div", {
      className: "live-infos__live"
    }, labels.live), liveDate, "\xA0", liveTime, " - ", liveDuration, " ", labels.durationUnit);
  };

  LiveInfos.propTypes = {
    className: _propTypes.default.string,
    isLive: _propTypes.default.bool,
    labels: _propTypes.default.shape({
      live: _propTypes.default.string.isRequired,
      durationUnit: _propTypes.default.string.isRequired
    }).isRequired,
    liveDate: _propTypes.default.string.isRequired,
    liveDuration: _propTypes.default.number.isRequired,
    liveTime: _propTypes.default.string.isRequired
  };
  LiveInfos.defaultProps = {
    className: '',
    isLive: true,
    labels: {
      live: 'Direct',
      durationUnit: 'min'
    },
    liveDate: '',
    liveDuration: '',
    liveTime: ''
  };
  var _default = LiveInfos;
  _exports.default = _default;
});